import { NavLink, useLocation } from "react-router-dom";
import PageTransition from "@/components/PageTransition";
import { Home, User, Bell, ListChecks, FileCheck } from "lucide-react";
import { tr as t } from "@/lib/i18n";

const ITEMS = [["/driver/account", "حسابي", User], ["/driver/notifications", "إشعاراتي", Bell], ["/driver", "الرئيسية", Home], ["/driver/trips", "نقلاتي", ListChecks], ["/driver/documents", "مستنداتي", FileCheck]];

function BottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 max-w-md mx-auto bg-brand rounded-t-[1.6rem] safe-bottom pt-2 shadow-[0_-6px_20px_rgba(1,59,121,0.25)]" data-testid="driver-bottom-nav">
      <div className="flex items-end justify-around text-[11px]">
        {ITEMS.map(([to, label, I]) => (
          <NavLink key={to} to={to} end data-testid={`driver-nav-${to.split("/")[2] || "home"}`}
            className={({ isActive }) => (to === "/driver" ? "flex flex-col items-center -mt-8 font-bold text-white" : `flex flex-col items-center gap-1 w-16 text-center leading-tight ${isActive ? "text-white font-bold" : "text-white/60"}`)}>
            {to === "/driver"
              ? <><span className="w-16 h-16 rounded-full bg-white text-brand flex items-center justify-center border-[5px] border-[#F2F6FB] shadow-lg"><Home className="w-7 h-7" /></span>{t(label)}</>
              : <><I className="w-6 h-6" />{t(label)}</>}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default function DriverShell() {
  const { pathname } = useLocation();
  const showNav = !pathname.startsWith("/driver/trips/");
  return (
    <div className="min-h-screen bg-brand-soft">
      <div className={`max-w-md mx-auto min-h-screen bg-[#F2F6FB] shadow-xl relative ${showNav ? "pb-28" : "pb-10"}`}>
        <PageTransition />
      </div>
      {showNav && <BottomNav />}
    </div>
  );
}
